
import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-stone-900 text-center">Hikayemiz</h1>
        <div className="aspect-video rounded-[3rem] overflow-hidden bg-stone-100">
           <img src="https://images.unsplash.com/photo-1572063816113-52729c391605?auto=format&fit=crop&q=80&w=1200" className="w-full h-full object-cover" alt="Hakkımızda" />
        </div>
        <div className="prose prose-stone lg:prose-xl mx-auto text-stone-600 leading-relaxed font-medium space-y-6">
          <p>Lumina Home, el yapımı tasarımın ve evdeki huzurun birleştiği bir noktada doğdu. Sanatın ve zanaatın gücüne inanıyoruz.</p>
          <p>Her bir mumumuz ve biblomuz, atölyemizde özenle, doğal malzemeler kullanılarak üretilmektedir. Bizim için bir objeden daha fazlası; bir atmosfer, bir anı ve bir duygu yaratmak önceliğimizdir.</p>
          <p>Siz de yaşam alanınıza ruh katacak parçalar arıyorsanız, koleksiyonlarımızı incelemekten keyif alacaksınız. Bu yolculukta yanımızda olduğunuz için teşekkür ederiz.</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
